import { render, staticRenderFns } from "./RegisterFirstStep.vue?vue&type=template&id=b866dd24&scoped=true&"
import script from "./RegisterFirstStep.vue?vue&type=script&lang=js&"
export * from "./RegisterFirstStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFirstStep.vue?vue&type=style&index=0&id=b866dd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b866dd24",
  null
  
)

export default component.exports